import type { ApiClient } from '../rest-api/generated/laravel-typed-openapi';

/** One person in the active organization, as `GET /organization/members` returns them. */
export type OrganizationMember = {
  /** `users.id`: what a trip's skipper and co-skipper and a task's assignees store. */
  id: number;
  name: string | null;
  surname: string | null;
  email: string | null;
};

/**
 * The active organization's members (MDC-4578): the only people the API accepts as a newly named
 * skipper, co-skipper or task assignee. Naming anyone else is refused with a sync error, so the
 * pickers offer exactly this list.
 */
export const fetchOrganizationMembers = async (apiClient: ApiClient): Promise<OrganizationMember[]> => {
  const { data } = await apiClient.get('/organization/members');

  return data;
};

/** How a member is shown in a picker: their name, else their email, never blank. */
export const organizationMemberName = ({ id, name, surname, email }: OrganizationMember): string =>
  [name, surname].filter(Boolean).join(' ').trim() || email || `Member ${id}`;
